import * as React from 'react';

const useRefreshInterval = (callback: () => void, immediate = false, intervalMinutes = 5) => {
  React.useEffect(() => {
    let timer: NodeJS.Timeout;
    let lastExecutionTime = Date.now();

    const getNextRefreshTime = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const nextRefreshMinutes = Math.ceil(minutes / intervalMinutes) * intervalMinutes;
      const delay = ((nextRefreshMinutes - minutes) * 60 - seconds) * 1000;
      return delay > 0 ? delay : intervalMinutes * 60 * 1000;
    };

    const scheduleNextRefresh = () => {
      const nextRefreshTime = getNextRefreshTime();
      timer = setTimeout(() => {
        const currentTime = Date.now();
        if (currentTime - lastExecutionTime >= intervalMinutes * 60 * 1000) {
          callback();
          lastExecutionTime = currentTime;
        }
        scheduleNextRefresh();
      }, nextRefreshTime);
    };

    if (immediate) {
      callback();
    }
    lastExecutionTime = Date.now();
    scheduleNextRefresh();

    return () => clearTimeout(timer);
  }, [callback, immediate, intervalMinutes]);
};

export default useRefreshInterval;
